import {
    deleteOffer,
    fetchOffer,
    saveOffer,
    updateOffer,
} from '../reducers/recordsSlice';
import {recordSelector} from '../selectors';
import {
    useAppDispatch,
    useAppSelector
} from '../../../hooks/useTypedReactRedux';
import {Offer} from '../types';

export const useOffer = (offerId?: string) => {


    const dispatch = useAppDispatch();

    const {
        record,
        loading,
    } = useAppSelector((state) =>
                           recordSelector(state, offerId ? offerId : ''),
    );

    // FETCH
    const fetchRecord = () => {
        if (typeof offerId === 'undefined') {
            throw new Error('offerId is required parameter');
        }
        dispatch(fetchOffer(offerId));
    };

    // CREATE, UPDATE DELETE
    const createRecord = (values: Offer) => {
        dispatch(saveOffer(values));
    };

    const updateRecord = (values: Offer) => {
        if (typeof offerId === 'undefined') {
            throw new Error('offerId is required parameter');
        }

        dispatch(updateOffer({
                                 id: offerId,
                                 record: values,
                             }));
    };

    const deleteRecord = () => {
        if (typeof offerId === 'undefined') {
            throw new Error('offerId is required parameter');
        }
        dispatch(deleteOffer(offerId));
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
